class MainProduct extends HTMLElement {
  constructor() {
    super();
    this.data = this.querySelector("#product-json");
    this.variantListeners = this.querySelectorAll("[data-variant-listener]");
    this.freeShipping = this.querySelector("#product-form__free-shipping");
    this.productId = this.dataset.productId;
    this.inputSubscriptionIntervalOverride = "";
    this.inputSubscriptionIntervalTypeOverride = "";
    try {
      const sellingPlanText = this.querySelector("#selling-plan-json");
      if (sellingPlanText)
        this.sellingPlanJson = JSON.parse(sellingPlanText.textContent);
      else this.sellingPlanJson = [];
    } catch (e) {
      this.sellingPlanJson = [];
    }
    try {
      this.fallBackOptions = JSON.parse(this.dataset.fallbackOptions);
    } catch (e) {
      this.fallBackOptions = null;
    }
    this.percentageInfo = this.querySelectorAll("[data-percent]");
    this.variantOptions = this.querySelectorAll(`[data-variant-option]`);
    this.subOption = this.querySelector(
      `product-options[data-subscription-option]`
    );
    this.disabledOptions = this.querySelector(
      "#disabled-options-" + this.productId
    );
    this.modelButton = this.querySelector(".view-3d-modal__icon");
    this.benefitsContainers =
      this.querySelectorAll(
        `[data-product-benefits="benefits-${this.productId}"]`
      ) || [];
    this.productForm = this.querySelector('[data-product-form="true"]');
    if (this.productForm) {
      this.defaultLimit =
        this.productForm.querySelector('[name="properties[_productLimit]"]')
          .value || "";
    }
    this.mediaContainers = Array.from(
      this.querySelectorAll(
        `[data-product-media="media-${this.productId}"] img`
      )
    );
    this.quantitySelector = this.querySelector("quantity-input");
    this.quantity = 1;
    this.priceContainers = this.querySelectorAll(
      `[data-product-price="price-${this.productId}"]`
    );
    this.pricePerMonthContainers = this.querySelectorAll(
      `[data-product-price-pm="price-pm-${this.productId}"]`
    );
    this.intervalOptionSelect = this.querySelector(
      "subscription-interval-selector"
    );
    this.inputSubscriptionInterval = this.querySelector(
      `#subscription-option-${this.productId}:not([data-sub-program="true"])`
    );
    this.intervalSubscriptionWrapper = this.querySelector(
      `[data-subscription-interval="sub-interval-${this.productId}"]`
    );
    this.priceTotalContainers = this.querySelectorAll(
      `[data-product-price-total="price-total-${this.productId}"]`
    );
    this.nonDiscountedPriceContainers = this.querySelectorAll(
      `[data-product-price-nd="price-nd-${this.productId}"]`
    );
    this.subPriceContainers = this.querySelectorAll(
      `[data-product-sub-price="sub-price-${this.productId}"]`
    );
    this.comparePriceContainers = this.querySelectorAll(
      `[data-product-compare-price="compare-price-${this.productId}"]`
    );
    this.variantTitlesContainers = this.querySelectorAll(
      `[data-variant-title="variant-title-${this.productId}"]`
    );
    this.bundleContainers = this.querySelectorAll("[data-bundle-save]");
    this.subscriptionProgramV2 = this.querySelector(
      "subscription-program-v2:not([data-hide='true'])"
    );
    this.load();
  }

  load() {
    try {
      this.data = this.querySelector("#product-json");
      this.productData = JSON.parse(this.data.textContent);
      this.pdpCarousel = this.querySelector("custom-carousel");
      this.updateOptions();
      this.updateDisabledOptions();
      this.getAvailableVariants();
      this.addListeners();
    } catch (e) {
      this.productData = null;
    }
  }
  overrideSubscriptionInterval(interval, intervalType) {
    this.inputSubscriptionIntervalOverride = interval;
    this.inputSubscriptionIntervalTypeOverride = intervalType;
    this.dispatchEvent(new CustomEvent("change"));
  }
  updateDisabledOptions() {
    if (this.disabledOptions) {
      if (!this.disabledOptionsData) {
        this.disabledOptionsData = JSON.parse(this.disabledOptions.textContent);
        if (this.fallBackOptions) {
          const cache = [];
          this.disabledOptionsData.filter((options, index) => {
            const otherFallBackOptions = this.fallBackOptions.filter(
              (i) => options.indexOf(i) === -1
            );
            const nonFallBackOptions = options.filter(
              (i) => this.fallBackOptions.indexOf(i) === -1
            );
            this.disabledOptionsData.forEach((option) => {
              if (
                option.every(
                  (o) =>
                    otherFallBackOptions.indexOf(o) !== -1 ||
                    nonFallBackOptions.indexOf(o) !== -1
                )
              ) {
                cache.push(option);
              }
            });
          });
          this.disabledOptionsData = cache;
        }
      }
      let disabled = this.getDisabledOptions().flat() || [];
      this.variantOptions.forEach((node) => {
        if (
          disabled.find(
            (j) => j.toLowerCase().trim() === node.value.toLowerCase().trim()
          ) &&
          node.dataset.allowDisabling !== "false"
        ) {
          node.setAttribute("data-oos", true);
        }
      });
    }
  }
  getDisabledOptions() {
    const disabled = [];
    if (this.optionsValues.length < 2) {
      this.disabledOptionsData.forEach((i) => disabled.push(i));
    } else {
      this.optionsValues.forEach((option) => {
        const otherSelectedOptions = this.optionsValues.filter(
          (i) => i !== option
        );
        this.disabledOptionsData.forEach((j) => {
          if (
            otherSelectedOptions.every((i) => {
              return j.indexOf(i) !== -1;
            })
          ) {
            disabled.push(
              j.filter((l) => otherSelectedOptions.indexOf(l) === -1)
            );
          }
        });
      });
    }
    return disabled;
  }

  onVariantChange(evt) {
    if (!this.data) {
      return;
    }
    this.updateOptions();
    if (this.subOption) {
      this.updateSubOptions();
    }
    this.getCurrentVariant(evt);
    if (this.intervalOptionSelect) {
      this.intervalOptionSelect.updateIntervalValue(evt, this.currentVariant);
    }
    this.updateUrl();
    this.updatePrices();
    if (this.productForm) {
      this.updateForm();
    }
    this.resetOverrideIntervalValues();
  }

  getAvailableVariants() {
    this.availableVariants = [];
    this.productData.variants.forEach((variant) => {
      if (variant.available) {
        this.availableVariants.push(variant.options);
      }
    });
  }

  addListeners() {
    this.addEventListener("change", this.onVariantChange);
    if (this.quantitySelector) {
      this.quantitySelector.addEventListener(
        "change",
        this.updatePrices.bind(this)
      );
    }
  }

  updateSubOptions() {
    const selectedSubOption = this.subOption.querySelector(
      'input:checked[data-type="option"]:not([data-simple=true])'
    );
    if (selectedSubOption && selectedSubOption.dataset) {
      this.isSubProgramV2 = !!selectedSubOption.dataset.subProgramV2;
    }
    if (!this.isSubProgramV2 && this.subscriptionProgramV2) {
      this.subscriptionProgramV2.updateForm(true);
    } else {
      if (!this.subValue) {
        this.productForm.querySelector('[name="selling_plan"]') &&
          (this.productForm.querySelector('[name="selling_plan"]').value = "");
      }
      this.subValue = selectedSubOption.value;
      if (this.subscriptionProgramV2) {
        this.subscriptionProgramV2.updateForm();
      }
    }
    if (this.productForm && !this.subscriptionProgramV2) {
      this.productForm.querySelector('[name="properties[_interval]"]').value =
        this.subValue;
    }
  }
  updateOptions() {
    this.optionsNodes = this.querySelectorAll(
      "input:checked[data-variant-option],select[data-variant-option]"
    );
    if (this.optionsNodes) {
      this.optionsValues = Array.from(this.optionsNodes).map((i) => i.value);
      return;
    }
    this.optionsValues = [];
  }

  getCurrentVariant(evt) {
    let result = this.productData.variants.find((variant) => {
      return this.optionsValues.every((option) =>
        variant.options.includes(option)
      );
    });
    if (this.fallBackOptions && !result.available) {
      const otherOptions = this.optionsValues.filter(
        (option) => this.fallBackOptions.indexOf(option) === -1
      );
      const otherFallbackOptions = this.fallBackOptions.filter(
        (i) => this.optionsValues.indexOf(i) === -1
      );
      result = this.productData.variants.find((variant) => {
        for (let o = 0; o < otherFallbackOptions.length; o++) {
          const optionsSearch = [...otherOptions, otherFallbackOptions[o]];
          if (
            optionsSearch.every(
              ((op) => variant.options.indexOf(op) !== -1) ||
                o === otherFallbackOptions.length - 1
            )
          ) {
            return true;
          }
        }
      });
    }
    if (!result) {
      this.updateOptionsData(false);
      return;
    }
    if (
      !this.currentVariant ||
      (this.currentVariant && this.currentVariant.id !== result.id)
    ) {
      this.currentVariant = result;
    }
    this.handleSellingPlanSelect();
    if (this.variantTitlesContainers.length)
      this.variantTitlesContainers.forEach((node) => {
        let delimiter = "<span class='divider'>•</span>";
        let variant_text = "";
        variant_text = this.currentVariant.title
          .split("/")
          .map((item, index) => {
            return `<span class='variant-title__item'>${item}</span> `;
          })
          .join(delimiter);
        node.innerHTML = variant_text;
      });
    if (this.variantListeners) {
      this.variantListeners.forEach((j) =>
        j.setAttribute(j.dataset.variantListener, this.currentVariant.id)
      );
    }
    if (this.benefitsContainers.length) {
      const current_benefits = this.currentVariant.top_benefits || null;
      this.benefitsContainers.forEach((node) => {
        node.innerHTML = current_benefits;
      });
    }
    if (this.modelButton) {
      const model =
        this.productData &&
        this.productData.models.length &&
        this.productData.models.find((modelItem) =>
          this.currentVariant.options.find(
            (option) =>
              modelItem &&
              modelItem.alt &&
              modelItem.alt.toLowerCase().includes("_" + option.toLowerCase())
          )
        );
      if (!model) {
        this.modelButton.classList.add("hidden");
      } else {
        this.modelButton.classList.remove("hidden");
      }
    }
    if (evt.target.dataset.color) {
      this.dispatchEvent(
        new CustomEvent("color-change", {
          detail: { color: evt.target.value, bubbles: false },
        })
      );
    }
    if (evt.target.dataset.variantOption === "true") {
      if (evt.target.dataset.changePdpMedia === "true" && this.pdpCarousel) {
        this.changeMediaPDP();
      }
      this.updateOptionsData(this.currentVariant.available);
      this.dispatchEvent(
        new CustomEvent("variant-change", {
          detail: {
            currentVariant: this.currentVariant,
            shouldChangePdpMedia: evt.target.dataset.changePdpMedia === "true",
          },
          bubbles: false,
        })
      );
    }
  }

  updateOptionsData(available) {
    let marketAvailability = true;
    if (this.productForm)
      marketAvailability =
        this.productForm
          .querySelector("button")
          .getAttribute("data-market-availability") !== "false";
    if (this.productForm && marketAvailability) {
      this.productForm
        .querySelectorAll("button.product-form__submit")
        .forEach((i) => i.removeAttribute("disabled"));
      this.productForm
        .querySelectorAll("[data-upsell-modal]")
        .forEach((i) => i.removeAttribute("disabled"));
    }
    if (!this.optionsNodes.length) return;
    this.variantOptions.forEach((option) => {
      option.removeAttribute("data-oos");
    });
    if (!available) {
      this.optionsNodes.forEach((i) => {
        i.setAttribute("data-oos", true);
        if (i.tagName.toLowerCase() === "select") {
          let disabled = this.getDisabledOptions().flat() || [];
          let options = Array.prototype.slice.call(i.childNodes);
          options.forEach((k) => {
            if (!k.value) return;
            if (disabled.includes(k.value.toLowerCase().trim())) {
              k.setAttribute("data-oos", true);
            }
          });
        }
      });
      if (this.productForm) {
        this.productForm.querySelectorAll("button").forEach((btn) => {
          btn.disabled = true;
        });
      }
    }
    this.updateDisabledOptions();
  }

  changeMediaPDP() {
    const mediaChangeEvent = new CustomEvent("media-change", {
      detail: {
        media: [
          ...this.currentVariant.media,
          ...this.productData.images_no_variants,
        ],
        media_alt: [
          ...this.currentVariant.media_alt,
          ...this.productData.images_no_variants.map((i) => "product alt"),
        ],
      },
    });
    this.dispatchEvent(mediaChangeEvent);
  }

  updatePrices() {
    if (!this.currentVariant) return;
    if (this.quantitySelector)
      this.quantity = this.quantitySelector.getQuantity();
    const subscriptionDiscount =
      (this.currentVariant.price * this.productData.subscription_discount) /
      100;
    let currentVariantPrice;

    if (this.subscriptionProgramV2) {
      currentVariantPrice = this.currentVariant.price;
    } else {
      if (this.currentSellingPlan) {
        currentVariantPrice = this.subValue
          ? this.currentSellingPlan.selling_plan_price
          : this.currentVariant.price;
      } else {
        currentVariantPrice = this.subValue
          ? this.currentVariant.price - subscriptionDiscount
          : this.currentVariant.price;
      }
    }
    const discountedVariantPrice = Math.round(
      this.currentVariant.price - subscriptionDiscount
    );
    const totalPrice = currentVariantPrice * this.quantity;
    if (this.freeShipping) this.handleFreeShipping(totalPrice);
    this.dispatchEvent(
      new CustomEvent("productPriceChange", { detail: totalPrice })
    );
    this.handlePercentageInfo();
    this.priceContainers.forEach((i) => {
      if (this.isSubProgramV2) return;
      if (i.dataset.formItem === "true" && !this.currentVariant.available) {
        i.innerText = theme.translations.sold_out;
      } else {
        i.innerHTML = formatMoney(currentVariantPrice).toUpperCase();
      }
    });
    if (!this.isSubProgramV2) {
      this.priceTotalContainers.forEach((i) => {
        if (i.dataset.formItem === "true" && !this.currentVariant.available) {
          i.innerText = theme.translations.sold_out;
        } else {
          i.innerText = formatMoney(totalPrice);
        }
      });
    }
    this.pricePerMonthContainers.forEach((node) => {
      const subscriptionInterval = this.getSubscriptionInterval();
      let variantPrice = this.currentVariant.subscription_variant_price;
      if (
        this.currentSellingPlan &&
        this.currentSellingPlan.selling_plan_price
      ) {
        variantPrice = this.currentSellingPlan.selling_plan_price;
      }
      let priceSubItems = 0;
      if (variantPrice) {
        if (
          this.currentSellingPlan &&
          this.currentSellingPlan.selling_plan_price
        ) {
          priceSubItems = this.currentSellingPlan.selling_plan_price;
        } else {
          const subDiscount =
            (variantPrice * this.productData.subscription_discount) / 100;
          priceSubItems = variantPrice - subDiscount;
        }
      }
      node.innerText = formatMoney(priceSubItems / subscriptionInterval);
    });
    if (
      this.currentVariant.subscription_interval &&
      this.intervalSubscriptionWrapper
    ) {
      this.intervalSubscriptionWrapper.innerText =
        this.getSubscriptionInterval();
    }
    if (
      this.currentVariant.subscription_interval_type &&
      this.inputSubscriptionInterval
    ) {
      this.inputSubscriptionInterval.value =
        this.getSubscriptionIntervalWithType();
    }
    if (
      this.inputCardSubscriptionInterval &&
      this.currentVariant.subscription_interval_type
    ) {
      this.inputCardSubscriptionInterval.value =
        this.getSubscriptionIntervalWithType();
    }
    this.subPriceContainers.forEach((node) => {
      node.innerText = formatMoney(discountedVariantPrice);
    });
    this.nonDiscountedPriceContainers.forEach((node) => {
      node.innerText = formatMoney(this.currentVariant.price);
    });
    if (this.subOption) {
      this.subOption
        .querySelectorAll("[data-product-save]")
        .forEach(
          (s) =>
            (s.innerHTML = formatMoney(
              this.currentVariant.price - discountedVariantPrice
            ).toUpperCase())
        );
    }
    this.comparePriceContainers.forEach((i) => {
      const currentPrice = +Number(i.innerHTML).toFixed(2);
      const bundle_total_price =
        this.currentVariant.bundle_total_price *
        this.currentVariant.bundle_multiplier;
      const compare_at_price = Number(this.currentVariant.compare_at_price);
      if (compare_at_price > 0 && compare_at_price !== currentPrice) {
        i.classList.remove("hidden");
        i.innerHTML = formatMoney(compare_at_price).toUpperCase();
        return;
      }
      if (bundle_total_price !== currentPrice) {
        i.innerHTML = formatMoney(bundle_total_price).toUpperCase();
      }
      if (compare_at_price === 0 && bundle_total_price === 0) {
        i.classList.add("hidden");
      }
    });
    this.bundleContainers.forEach((node) => {
      const totalPriceBundle =
        this.currentVariant.compare_at_price ||
        this.currentVariant.bundle_total_price ||
        this.currentVariant.price;
      node.innerText = Math.ceil(
        100 - (currentVariantPrice * 100) / totalPriceBundle
      );
    });
  }
  handleFreeShipping(totalPrice) {
    if (totalPrice > theme.shop.free_shipping * 100) {
      this.freeShipping.classList.replace("d-none", "d-flex");
    } else {
      this.freeShipping.classList.replace("d-flex", "d-none");
    }
  }
  updateForm() {
    if (!this.productForm || !this.currentVariant) return;
    this.productForm.querySelector("input[name='id']").value =
      this.currentVariant.id;
    if (
      this.subOption &&
      this.currentVariant.subscription_interval_type &&
      this.productForm &&
      !this.subscriptionProgramV2
    ) {
      const selectedSubOption = this.subOption.querySelector(
        'input:checked[data-type="option"]:not([data-simple=true])'
      );
      this.productForm.querySelector('[name="properties[_interval]"]').value =
        selectedSubOption.value;
      if (
        this.currentSellingPlan &&
        this.currentSellingPlan.selling_plan_id &&
        this.subValue
      ) {
        this.productForm.querySelector(
          '[name="properties[_interval]"]'
        ).value = `${this.currentSellingPlan.interval_count}${this.currentSellingPlan.interval}`;
      }
      const sellingPlanInput = this.productForm.querySelector(
        '[name="selling_plan"]'
      );
      const sellingPlanProperty = this.productForm.querySelector(
        '[name="properties[_selling_plan]"]'
      );
      if (
        this.currentSellingPlan &&
        this.currentSellingPlan.selling_plan_id &&
        selectedSubOption.value &&
        sellingPlanInput &&
        !this.isSubProgramV2
      ) {
        sellingPlanInput.value = this.currentSellingPlan.selling_plan_id;
        sellingPlanProperty &&
          (sellingPlanProperty.value = this.currentSellingPlan.selling_plan_id);
      } else {
        sellingPlanInput.value =
          selectedSubOption.value && sellingPlanProperty.value
            ? sellingPlanProperty.value
            : "";
      }
    }
  }

  updateUrl() {
    const url = new URL(window.location.href);
    if (this.currentVariant && this.currentVariant.id)
      url.searchParams.set("variant", this.currentVariant.id);
    history.replaceState({ path: url.toString() }, "", url.toString());
  }
  getSubscriptionInterval() {
    let subscriptionInterval = this.currentVariant.subscription_interval
      ? this.currentVariant.subscription_interval
      : this.productData.subscription_interval;
    return this.inputSubscriptionIntervalOverride || subscriptionInterval;
  }
  getSubscriptionIntervalWithType() {
    let subscriptionIntervalType = this.currentVariant
      .subscription_interval_type
      ? this.currentVariant.subscription_interval_type
      : this.productData.subscription_interval_type;
    const intervalSelector = this.querySelector(
      "subscription-interval-selector"
    );
    if (intervalSelector && intervalSelector.style.display !== "none") {
      this.customInterval = intervalSelector.querySelector(
        "select.product-options__interval-select"
      );
    }
    return this.customInterval && this.customInterval.value
      ? this.customInterval.value
      : this.inputSubscriptionIntervalTypeOverride || subscriptionIntervalType;
  }
  resetOverrideIntervalValues() {
    this.inputSubscriptionIntervalOverride = "";
    this.inputSubscriptionIntervalTypeOverride = "";
  }

  handleSellingPlanSelect() {
    const interval =
      this.inputSubscriptionIntervalOverride ||
      this.currentVariant.subscription_interval;
    if (this.sellingPlanJson && interval) {
      const selectedPlan = this.sellingPlanJson.find((plan) => {
        return (
          plan[this.currentVariant.id] &&
          plan[this.currentVariant.id].interval_count == interval
        );
      });
      if (selectedPlan && this.currentVariant.id) {
        this.currentSellingPlan = selectedPlan[this.currentVariant.id];
      } else {
        this.currentSellingPlan = "";
      }
    }
  }

  handlePercentageInfo() {
    if (!this.currentSellingPlan || !this.currentSellingPlan.selling_plan_price)
      return;
    const currentPercentage = Math.round(
      (1 -
        this.currentSellingPlan.selling_plan_price /
          this.currentVariant.price) *
        100
    );
    this.percentageInfo.forEach((node) => {
      node.innerHTML = currentPercentage;
    });
  }
}

if (!customElements.get("main-product")) {
  customElements.define("main-product", MainProduct);
}

class ProductVariantSelects extends MainProduct {
  constructor() {
    super();
    this.updateRelatedOptions = this.dataset.updateRelatedOptions;
    this.includedInBox = this.querySelector(".included_in_box");
  }
  load() {
    this.productData = null;
    if (this.dataset.productDetail) {
      const json = this.querySelector("#" + this.dataset.productDetail);
      try {
        this.productData = JSON.parse(json.textContent);
        this.variantsData = this.productData.variants;
      } catch (e) {
        logger.error(`Component Product error:${e}`);
      }
    }
    this.urlContainers = this.querySelectorAll(
      `[data-product-url="url-${this.productId}"]`
    );
    this.inputCardSubscriptionInterval = this.querySelector(
      `[id^="subscription-option-${this.productId}"]`
    );
    this.updateOptions();
    this.updateDisabledOptions();
    this.addListeners();
  }

  addListeners() {
    this.addEventListener("change", this.onVariantChange);
  }

  async onVariantChange(evt) {
    const submitBtn = this.querySelector(".product-form__submit");
    if (!this.productData) {
      submitBtn && submitBtn.classList.add("loading");
      await this.loadData();
      submitBtn && submitBtn.classList.remove("loading");
      this.getAvailableVariants();
    }
    if (this.variantsData) {
      this.updateOptions();
      if (this.subOption) {
        this.updateSubOptions();
      }
      this.getCurrentVariant(evt);
      if (this.intervalOptionSelect) {
        this.intervalOptionSelect.updateIntervalValue(evt, this.currentVariant);
      }
      this.updatePrices();
      this.updateMedia();
      this.updateIncluded();
      this.updateForm();
      this.updateURL();
      this.updateRelatedOption(evt.target.value);
    }
  }

  async loadData() {
    await apiFetchText(`${this.dataset.url}`, "?view=product-json").then(
      (responseText) => {
        const html = new DOMParser()
          .parseFromString(responseText, "text/html")
          .querySelector("#product-json");
        try {
          this.productData = JSON.parse(html.textContent);
          this.variantsData = this.productData.variants;
        } catch (e) {
          this.productData = null;
        }
      }
    );
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (this.currentVariant.featured_media) {
      let _this = this;
      if (this.mediaContainers) {
        this.mediaContainers.forEach((i) => {
          const mediaQuery = i.src.split("?")[1] || "";
          if (
            i.classList.contains("product-card__hover-asset") &&
            this.currentVariant.hover_media
          ) {
            i.srcset = `${this.currentVariant.hover_media.src}?${mediaQuery}`;
            i.alt = this.currentVariant.hover_media.alt;
          } else {
            i.srcset = `${this.currentVariant.featured_media.preview_image.src}?${mediaQuery}`;
            i.alt = this.currentVariant.featured_media.preview_image.alt;
          }
          i.onload = function () {
            i.style.transition = "unset";
            i.style.opacity = 0;
            setTimeout(() => {
              i.style.transition = "opacity .6s ease,transform .5s";
              i.style.opacity = 1;
            }, 200);
          };
        });
      }
    }
  }
  updateIncluded() {
    if (
      !this.currentVariant ||
      !this.currentVariant.whats_in_the_box ||
      !this.includedInBox
    )
      return;
    this.includedInBox.innerHTML = this.currentVariant.whats_in_the_box;
  }
  updateURL() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.available) return;
    if (this.urlContainers.length) {
      this.urlContainers.forEach((i) => {
        i.href = `${this.dataset.url}?variant=${this.currentVariant.id}`;
      });
    }
  }

  updateRelatedOption(optionSelector) {
    if (this.updateRelatedOptions) {
      Array.from(
        document.querySelectorAll(
          `[data-variant-option="true"][value=${optionSelector}]`
        )
      ).forEach((relatedOptionSelector) => {
        relatedOptionSelector.click();
      });
    }
  }
}

if (!customElements.get("product-item-variant-selector")) {
  customElements.define("product-item-variant-selector", ProductVariantSelects);
}

class ProductOptions extends HTMLElement {
  constructor() {
    super();
    this.root = this.closest("product-item-variant-selector");
    this.optionName = this.dataset.optionName;
    this.labelValues = this.querySelectorAll(
      "[data-option-value]:not([data-ignore-change])"
    );
    this.productInfoWrapper = this.closest("main-product");
    this.addListeners();
    this.initSelectedOptionFromQuery();
    this.initialiseBwp();
  }
  initialiseBwp() {
    if (!this.productInfoWrapper) return;
    const inputOtp = this.productInfoWrapper.querySelector(
      'input[id^="otp-option"]'
    );
    const isOtpSelected = inputOtp && inputOtp.checked;
    const elementBwP = this.productInfoWrapper.querySelector(
      ".delivery-promise__promise-container"
    );
    if (elementBwP) {
      elementBwP.style.cssText = isOtpSelected
        ? "display: block"
        : "display: none !important";
    }

    // While experiment is running, this will override the display property using !important
    if (isOtpSelected) {
      triggerExperiment("EXP_20240124_buy_prime");
    }
  }
  hideGrpPrices() {
    if (this.productInfoWrapper) {
      const subscriptionOption = this.productInfoWrapper.querySelector(
        ".product-options__subscription-option-wrapper.otp.active"
      );
      const isSubProgV2 =
        subscriptionOption &&
        subscriptionOption.closest("subscription-program-v2");
      this.grpPrices = Array.from(
        this.productInfoWrapper.querySelectorAll(".grp-price")
      );
      if (this.grpPrices) {
        this.grpPrices.forEach((price) => {
          price.style.opacity = subscriptionOption && !isSubProgV2 ? "0" : "1";
          price.style.display =
            subscriptionOption && !isSubProgV2 ? "none" : "inline";
        });
      }
    }
  }
  selectOptionByValue(optionKey) {
    const optionValue = theme.translations.option_values[optionKey];
    const optionValueMap = theme.translations.option_values_map[optionKey];
    const option =
      this.querySelector(`[value="${optionValue}"]`) ||
      this.querySelector(`[value="${optionValueMap}"]`);
    if (option) {
      option.click();
      this.setAttribute("data-option-set-from-query", true);
    }
  }

  initSelectedOptionFromQuery() {
    try {
      window.addEventListener("load", () => {
        const params = new URLSearchParams(window.location.search);
        this.selectOptionByValue(params.get("skin_type")); // We can add others as needed
        this.selectOptionByValue(params.get("color"));
        this.selectOptionByValue(params.get("trimmer_type"));
      });
    } catch (error) {
      // swallow
    }
  }

  addListeners() {
    if (this.labelValues) {
      this.addEventListener("change", (evt) => {
        this.handleImageLoader(evt);
        this.querySelectorAll(
          ".product-options__subscription-option-wrapper"
        ) &&
          this.querySelectorAll(
            ".product-options__subscription-option-wrapper"
          ).forEach((node) => node.classList.remove("active"));
        if (
          this.productInfoWrapper &&
          this.productInfoWrapper.querySelectorAll(
            ".product-options__subscription-option-wrapper"
          ).length > 1
        ) {
          Array.from(
            this.productInfoWrapper.querySelectorAll(
              ".product-options__subscription-option-wrapper"
            )
          )
            .find((el) =>
              el.querySelector(
                'input:checked[data-type="option"]:not([data-simple=true])'
              )
            )
            .classList.add("active");
        } else if (
          evt.target.closest(".product-options__subscription-option-wrapper")
        ) {
          evt.target
            .closest(".product-options__subscription-option-wrapper")
            .classList.add("active");
        }
        this.hideGrpPrices();
        this.initialiseBwp();
        this.labelValues.forEach((j) => {
          const value = evt.target.value;
          const valueKey = value.toLowerCase().replace(" ", "_");
          const translatedLabel = theme.translations.option_values[valueKey];
          j.innerHTML = translatedLabel || value;
        });
      });
    }
  }
  handleImageLoader(evt) {
    if (this.root) {
      this.root.classList.add("changing-variant");
      this.productCardImage = this.root.querySelector(".product-card__image");
      this.productCardImage &&
        this.productCardImage.addEventListener(
          "load",
          () => {
            setTimeout(() => {
              this.root.classList.remove("changing-variant");
            }, 600);
          },
          { once: true }
        );
      const bg_color =
        evt.target.value && theme.shop.background_colors_map
          ? theme.shop.background_colors_map[evt.target.value.toLowerCase()] ||
            ""
          : "";
      if (bg_color && this.root.classList.contains("alt-bg-design")) {
        this.root.style.background = bg_color;
      }
    }
  }
}

customElements.define("product-options", ProductOptions);
class SubscriptionProgramV2 extends HTMLElement {
  constructor() {
    super();
    if (this.dataset.hide === "true") {
      this.remove();
      return;
    }
    const priceContainerArray = document.querySelectorAll(
      "[data-current-price]"
    );
    const variantPrice = this.dataset.productPrice * 1
    priceContainerArray.forEach((priceContainer) => {
      priceContainer.innerText = formatMoney(variantPrice);
    });
    const stickyPDP = document.querySelector("pdp-add-to-cart");
    stickyPDP && stickyPDP.classList.remove("pdp-add-to-cart--enabled")
    this.data = this.querySelector("#sub-program-json");
    this.dataArray = JSON.parse(this.data.textContent);
    this.optionsContainer = this.querySelector(".sub-prog__container");
    this.consumablesSubPrice = this.querySelector(
      "[data-consumables-price-sub]"
    );
    this.productPrice = this.dataset.productPrice;
    this.mainProduct = this.closest("main-product");
    this.savePercentageContainer = this.mainProduct.querySelector(
      "[ data-save-percent-container]"
    );
    this.savePercentage = this.savePercentageContainer.querySelector(
      "[data-save-percent-program]"
    );
    this.otpPriceContainer = this.mainProduct.querySelector(
      ".grp-price[data-otp]"
    );
    this.grpPriceWrapper = this.mainProduct.querySelector(
      ".grp-price__wrapper"
    );
    this.offerPriceContainerArray = this.mainProduct.querySelectorAll(
      "[data-current-price]"
    );
    this.showMore = this.querySelector(".sub-prog-select__show-more");
    this.showLess = this.querySelector(".sub-prog-select__show-less");
    this.selectedVariantsIds = this.querySelector(
      'input[name="properties[_subscription-program-ids]"]'
    );
    this.selectedSlugs = this.querySelector(
      'input[name="properties[_subscription-program-slugs]"]'
    );
    this.selectedQuantities = this.querySelector(
      'input[name="properties[_subscription-program-qty]"]'
    );
    this.selectedOffers = this.querySelector(
      'input[name="properties[_subscription-program-offer]"]'
    );
    this.programItemsTotalPrice = this.querySelector(
      'input[name="properties[_subscription-program-price]"]'
    );
    this.selectedSellingPlans = this.querySelector(
      'input[name="properties[_subscription-program-selling-plans]"]'
    );
    this.showMore.addEventListener("click", () =>
      this.optionsContainer.classList.add("active")
    );
    this.showLess.addEventListener("click", () =>
      this.optionsContainer.classList.remove("active")
    );
    this.labelsArr = this.querySelectorAll(
      ".product-options__subscription-option-wrapper"
    );
    this.updateForm(false, this.labelsArr[0]);
    this.labelsArr.forEach((item) => {
      item.addEventListener("click", (e) =>
        this.updateForm(false, e.currentTarget)
      );
    });
    this.calculatePrices();
  }
  getFormStringFromObject(array, key) {
    if (array && array.length) {
      return array.reduce((c, v) => (c ? `${c};${v[key]}` : `${v[key]}`), "");
    }
    return "";
  }

  updateForm(reset = false, element) {
    const selectedColor = this.mainProduct.querySelector(
      "[data-color]:checked"
    ).value;
    this.dataArray.forEach((array, i) => {
      array.forEach((object, j) => {
        if (Object.keys(object).length) {
          const input = this.labelsArr[i].querySelector("input");
          const img = this.labelsArr[i].querySelectorAll("img")[j];
          img.src = object[selectedColor].src;
          img.removeAttribute("srcset");
          const replaceID = input.dataset.ids.split(";")[j];
          input.dataset.ids = input.dataset.ids.replace(
            replaceID,
            object[selectedColor].id
          );
        }
      });
    });
    element && (this.element = element);
    if (reset) {
      this.selectedQuantities.value = "";
      this.selectedVariantsIds.value = "";
      this.selectedSlugs.value = "";
      this.otpPriceContainer.style.display = "none";
      this.savePercentageContainer.style.display = "none";
      return;
    }
    this.selectedOffer = this.element.querySelector("input");
    if (this.selectedOffer.dataset.discountedPrice) {
      this.consumablesSubPrice.innerText = formatMoney(
        this.selectedOffer.dataset.discountedPrice * 1
      );
    }
    if (!this.selectedOffer.dataset.ids) return;
    const selectedOfferIdsArr = this.selectedOffer.dataset.ids.split(";");
    const selectedProductsSlugsArr =
      this.selectedOffer.dataset.productSlugs.split(";");
    const selectedOfferSlugsArr =
      this.selectedOffer.dataset.offersIds.split(";");
    const selectedOfferTitlesArr = this.selectedOffer.dataset.titles.split(";");
    const selectedOfferDiscountsArr =
      this.selectedOffer.dataset.discounts.split(";");
    const selectedSellingPlansArr =
      this.selectedOffer.dataset.sellingPlan.split(";");
    const selectedVariants = [];
    for (let i = 0; i < selectedOfferIdsArr.length; i++) {
      let price;
      if (i === 0) {
        price = this.selectedOffer.dataset.pricesUsd;
      } else {
        price = "0";
      }
      selectedVariants.push({
        quantity: "1",
        id: selectedOfferIdsArr[i],
        slug: selectedProductsSlugsArr[i],
        offerSlug: selectedOfferSlugsArr[i],
        price: price,
        title: selectedOfferTitlesArr[i],
        discount: selectedOfferDiscountsArr[i],
        sellingPlan: selectedSellingPlansArr[i],
      });
      this.selectedQuantities.value = this.getFormStringFromObject(
        selectedVariants,
        "quantity"
      );
      this.selectedVariantsIds.value = this.getFormStringFromObject(
        selectedVariants,
        "id"
      );
      this.selectedSlugs.value = this.getFormStringFromObject(
        selectedVariants,
        "slug"
      );
      this.selectedOffers.value = this.getFormStringFromObject(
        selectedVariants,
        "offerSlug"
      );
      this.programItemsTotalPrice.value = this.getFormStringFromObject(
        selectedVariants,
        "price"
      );
      this.selectedSellingPlans.value = this.getFormStringFromObject(
        selectedVariants,
        "sellingPlan"
      );
    }
    this.grpPriceWrapper.classList.add("active");
    this.calculatePrices();
  }
  calculatePrices() {
    const otpPrice =
      this.selectedOffer.dataset.variantPrice * 1 + this.productPrice * 1;
    const discountedPrice =
      this.productPrice * 1 + this.selectedOffer.dataset.prices * 1;
    this.otpPriceContainer.style.display = "inline";
    this.savePercentageContainer.style.displat = "inline";
    this.otpPriceContainer.innerText = formatMoney(otpPrice);
    this.offerPriceContainerArray.forEach((offerPrice) => {
      offerPrice.innerText = formatMoney(discountedPrice);
    });
    this.savePercentage.innerText = Math.round(
      100 - (discountedPrice / otpPrice) * 100
    );
  }
}
customElements.define("subscription-program-v2", SubscriptionProgramV2);
class SimpleVariantListener extends HTMLElement {
  constructor() {
    super();
    this.mainProduct = this.closest("main-product");
    this.productOptions = this.querySelectorAll(".product-options");
    this.jsonData = this.querySelector(".variantJson");
    this.productData = {};
    this.productImages = this.querySelectorAll(".sub-program__variant-img");
    try {
      this.currentVariant = JSON.parse(this.dataset.currentVariant);
    } catch (e) {
      this.currentVariant = {};
    }
    if (this.jsonData) {
      try {
        this.productData = JSON.parse(this.jsonData.textContent);
      } catch (e) {
        this.productData = {};
      }
    }
    this.selectButton = this.querySelector("button");
    this.modal = this.closest("modal-dialog");
    this.addListeners();
  }
  addListeners() {
    if (this.productOptions && this.mainProduct) {
      this.mainProduct.addEventListener("color-change", (evt) => {
        const color = evt.detail.color;
        const label = this.querySelector(`label[data-color='${color}']`);
        if (label) label.click();
        this.getVariantSelected(color);
      });
    }
    this.productOptions.forEach((node) => {
      node.addEventListener("change", (evt) => {
        const label = node.querySelector("[data-option-value]");
        const value = evt.target && evt.target.value;
        if (label && value) {
          label.innerText = value;
        }
      });
    });
  }
  handleSubmit() {
    if (this.selectButton) {
      this.selectButton.addEventListener("click", () => {
        this.dispatchEvent(
          new CustomEvent("change-checked", {
            bubbles: true,
            detail: {
              variant: this.currentVariant,
              inputId: this.dataset.inputId,
            },
          })
        );
        this.modal.hide();
      });
    }
  }
  getVariantSelected(selectedOption) {
    if (this.productData && this.productData.variants) {
      const variant = this.productData.variants.find((variant) => {
        return (
          variant.options.indexOf(selectedOption) !== -1 &&
          variant.available === true
        );
      });
      if (variant) this.currentVariant = variant;
      else return;
      if (
        this.productImages.length &&
        variant &&
        variant.featured_media &&
        variant.featured_media.src
      ) {
        this.dispatchEvent(
          new CustomEvent("sub-variant-change", {
            bubbles: true,
            detail: {
              productId: this.dataset.productId,
              variant: this.currentVariant,
            },
          })
        );
        this.productImages.forEach((node) => {
          const mediaQuery = node.src.split("?")[1] || "";
          node.srcset = `${variant.featured_media.src}&${mediaQuery}`;
        });
      }
    }
  }
  handleVariantChange() {
    this.addEventListener("change", (evt) => {
      evt.preventDefault();
      const selectedOption = evt.target.value;
      this.getVariantSelected(selectedOption);
    });
  }
  connectedCallback() {
    this.handleVariantChange();
    this.handleSubmit();
  }
}
customElements.define("simple-variant-listener", SimpleVariantListener);

class SubscriptionIntervalSelector extends HTMLElement {
  constructor() {
    super();
    this.optionSelect = this.querySelector(
      "select.product-options__interval-select"
    );
    this.parent = this.closest("main-product")
      ? this.closest("main-product")
      : this.closest("product-item-variant-selector");
    this.addEventListener("change", (evt) => {
      evt.stopImmediatePropagation();
      this.parent.overrideSubscriptionInterval(
        Number.parseInt(evt.target.value),
        evt.target.value
      );
    });
  }
  updateIntervalValue(evt, selectedVariant) {
    let targetElement = evt.target.closest("product-options");
    if (
      targetElement &&
      targetElement.getAttribute("data-size-option") &&
      targetElement.getAttribute("data-size-option") === "true"
    ) {
      this.optionSelect.value = selectedVariant.subscription_interval_type;
    }
  }
}
customElements.define(
  "subscription-interval-selector",
  SubscriptionIntervalSelector
);
